import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { api } from '../apis/configs/axiosConfigs';
import 'bootstrap/dist/css/bootstrap.min.css';

const Logout: React.FC = () => {
  const { setAuthToken } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const handleLogout = async () => {
      try {
        // Invalidate the shared Redis session on the BFF BEFORE clearing local state.
        // The `api` request interceptor reads authToken from localStorage to attach
        // XSessionId/XUserId/XUserEmail; clearing first would null the headers and the
        // backend would have no session to delete. Best-effort + idempotent (replaying
        // logout returns 401 from the auth handler). Mirrors the admin-portal logout.
        await api.post('/HardwareViewer/Account/logout');
      } catch (e) {
        // Log out locally regardless of the backend outcome.
      } finally {
        setAuthToken(null);
        console.log('Logged out');
        navigate('/login');
      }
    };
    handleLogout();
  }, [navigate, setAuthToken]);

  return (
    <div className="container mt-5">
        <p>Logging out ......</p>
    </div>
  );
};

export default Logout;
